export default {
  cpmLoginLogList: (state) => state.cpmLoginLogList,
  cpmLoginLogCount: (state) => state.cpmLoginLogCount,
  cpmUserList: (state) => state.cpmUserList,
  cpmUserCount: (state) => state.cpmUserCount,
  cpmUserDetail: (state) => state.cpmUserDetail
};
